import { FetchMyNotificationType } from '../redux/lounges/slice';
import { GET_BASE_URL } from '../constants/apiEndpoints';
import { readLoungeAuthorizedData } from '../utils/loungeAuthRefresh';

export const getAllMyNotificationApi = async ({
  sortType: _sortType,
  currentPage,
}: FetchMyNotificationType) => {
  localStorage.setItem('pagename', 'My Notifications');
  return readLoungeAuthorizedData(
    GET_BASE_URL + '/api/v1/notificationNew?currentPage=' + currentPage,
    'notificationNew'
  );
};
